import { render, staticRenderFns } from "./FbxModel.vue?vue&type=template&id=5238063c&scoped=true"
import script from "./FbxModel.vue?vue&type=script&lang=js"
export * from "./FbxModel.vue?vue&type=script&lang=js"
import style0 from "./FbxModel.vue?vue&type=style&index=0&id=5238063c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5238063c",
  null
  
)

export default component.exports